import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=6bc8b2f0&scoped=true"
import script from "./NewTag.vue?vue&type=script&setup=true&lang=js"
export * from "./NewTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NewTag.vue?vue&type=style&index=0&id=6bc8b2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc8b2f0",
  null
  
)

export default component.exports